import "./ExergyAudit.module.css";
import Header from "@/reusable_sections/Header";
import StartYourSolarJourney from "./sections/StartYourSolarJourney";
import TheAssessmentProcess from "./sections/TheAssessmentProcess";
import SystemFooter from "@/reusable_sections/Footer";
export default function ExergyAuditPage() {
  return <div>
      <Header />
      <StartYourSolarJourney />
      <TheAssessmentProcess />
      <SystemFooter />
    </div>;
}